import { arrayOf, func, number, object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';

import MultiSelect from '../../../generic/MultiSelect';
import api from '../../../REST/api';
import { getContentIdOptions } from '../utils';
import ContentEntryNameMenu from './ContentEntryNameMenu';

const colorStyles = {
  menuPortal: base => ({
    ...base,
    zIndex: 6000,
  }),
};

export default function ContentEntryNameSearch({
  chosenFilters,
  contentEntryNames,
  setChosenFilters,
  setContentEntryNames,
  campaignLineProducts,
  onClearSelected,
  minSearchLength,
  onSuccess,
  campaignId,
  debounceTime = 1000,
}) {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = newValue => {
    setInputValue(newValue);
    return newValue;
  };
  const handleAsyncLoad = (searchTerm, filters) => {
    const load = ({ search }) => api.getContentEntryName(search);

    setInputValue(searchTerm);

    const searchParameters = {
      contentName: searchTerm,
      productCodes: filters,
      campaignId,
    };

    if (searchTerm.length < minSearchLength) {
      return Promise.resolve([]);
    }
    return load({ search: searchParameters }).then(data => {
      const availableOptions = getContentIdOptions(data);
      setOptions(availableOptions);
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handleAsyncLoad(inputValue, chosenFilters);
    }, debounceTime);
    return () => {
      clearTimeout(handler);
    };
  }, [chosenFilters, inputValue]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectChange = event => {
    const selectedValues = event.target.value;
    const selectedOptions = options.filter(option =>
      selectedValues.includes(option.value),
    );
    setContentEntryNames(selectedOptions);
  };

  return (
    <MultiSelect
      options={options}
      id="contentEntryNameSearch"
      name="contentEntryNames"
      value={contentEntryNames.map(o => o.value)}
      onChange={handleSelectChange}
      onInputChange={handleInputChange}
      isClearable
      components={{
        MenuList: ContentEntryNameMenu,
      }}
      campaignLineProducts={campaignLineProducts}
      chosenFilters={chosenFilters}
      setChosenFilters={setChosenFilters}
      onClearSelected={onClearSelected}
      onSuccess={onSuccess}
      menuPosition="fixed"
      styles={colorStyles}
      closeMenuOnSelect={false}
      campaignId={campaignId}
    />
  );
}

ContentEntryNameSearch.propTypes = {
  campaignLineProducts: arrayOf(object), // eslint-disable-line react/forbid-prop-types,
  contentEntryNames: arrayOf(object), // eslint-disable-line react/forbid-prop-types,
  chosenFilters: arrayOf(string),
  setChosenFilters: func.isRequired,
  setContentEntryNames: func.isRequired,
  onClearSelected: func.isRequired,
  onSuccess: func.isRequired,
  minSearchLength: number.isRequired,
  campaignId: number.isRequired,
  debounceTime: number,
};

ContentEntryNameSearch.defaultProps = {
  contentEntryNames: [],
  campaignLineProducts: [],
  chosenFilters: [],
  debounceTime: undefined,
};
